import { RastreioCancerPerguntaDbEnum, RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'

export const MamografiaPerguntaField = {
  noduloCaroco: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_01_01,
  riscoCancerMama: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_01_02,
  mamasExaminadas: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_01_03,
  fezMamografia: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_01_04,
  anoUltimaMamografia: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_01_05,
  fezRadioterapia: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_01_06,
  anoRadioterapiaMamaDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_01_07,
  anoRadioterapiaMamaEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_01_08,
  radioterapiaLocalizacao: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_01_10,
  fezCirurgiaMama: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_01_09,
  biopsiaCirurgicaIncisionalDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_01,
  biopsiaCirurgicaIncisionalEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_02,
  biopsiaCirurgicaExcisionalDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_03,
  biopsiaCirurgicaExcisionalEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_04,
  centralectomiaDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_05,
  centralectomiaEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_06,
  segmentectomiaDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_07,
  segmentectomiaEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_08,
  dutectomiaDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_09,
  dutectomiaEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_10,
  mastectomiaDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_11,
  mastectomiaEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_12,
  mastectomiaPoupadoraPeleDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_13,
  mastectomiaPoupadoraPeleEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_14,
  mastectomiaPoupadoraPeleComplexoDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_15,
  mastectomiaPoupadoraPeleComplexoEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_16,
  linfadenectomiaAxilarDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_17,
  linfadenectomiaAxilarEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_18,
  biopsiaLinfonodoSentinelaDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_19,
  biopsiaLinfonodoSentinelaEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_20,
  reconstrucaoMamariaDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_21,
  reconstrucaoMamariaEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_22,
  mastoplastiaRedutoraDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_23,
  mastoplastiaRedutoraEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_24,
  inclusaoImplantesDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_25,
  inclusaoImplantesEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_26,
  tipoMamografia: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_03_01,
  mamografiaRastreamento: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_03_02,
  lesaoPapilarDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_04_01,
  descargaPapilarDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_04_02,
  linfonodoPalpavelDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_04_03,
  noduloLocalizacaoDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_04_04,
  espessamentoLocalizacaoDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_04_05,
  lesaoPapilarEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_05_01,
  descargaPapilarEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_05_02,
  linfonodoPalpavelEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_05_03,
  noduloLocalizacaoEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_05_04,
  espessamentoMamaEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_05_05,
  noduloControleRadio: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_06_01,
  microcalcificacoesControleRadio: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_06_02,
  assimetriaFocalControleRadio: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_06_03,
  assimetriaDifusaControleRadio: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_06_04,
  areaDensaControleRadio: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_06_05,
  distorcaoFocalControleRadio: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_06_06,
  linfonodoAxilarControleRadio: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_06_07,
  avaliacaoRespostaQuimioterapia: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_06_08,
  categoriaZero: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_07_01,
  categoriaTres: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_07_02,
  categoriaQuatro: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_07_03,
  categoriaCinco: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_07_04,
  noduloLesaoCancer: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_08_01,
  microcalcificacoesLesaoCancer: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_08_02,
  assimetriaFocalLesaoCancer: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_08_03,
  assimetriaDifusaLesaoCancer: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_08_04,
  areaDensaLesaoCancer: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_08_05,
  distorcaoFocalLesaoCancer: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_08_06,
  linfonodoAxilarLesaoCancer: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_08_07,
  dataSolicitacao: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_09_01,
  nomeResponsavel: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_09_02,
  cns: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_09_03,
  numeroConselho: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_09_04,
  siglaNomeConselho: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_09_05,
  noduloLesaoBenigna: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_10_01,
  microcalcificacoesLesaoBenigna: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_10_02,
  assimetriaFocalLesaoBenigna: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_10_03,
  assimetriaDifusaLesaoBenigna: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_10_04,
  areaDensaLesaoBenigna: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_10_05,
  distorcaoFocalLesaoBenigna: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_10_06,
  linfonodoAxilarLesaoBenigna: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_10_07,
} as const

type PerguntaFields = typeof MamografiaPerguntaField[keyof typeof MamografiaPerguntaField]

export type RequisicaoExameMamografiaFormValues = Partial<
  Record<PerguntaFields, RastreioCancerPerguntaOpcaoEnum | string>
> & {
  openedAccordions?: (string | number)[]
}

export const mamasExaminadasOptions = [
  { value: RastreioCancerPerguntaOpcaoEnum.SIM, label: 'Sim' },
  {
    value: RastreioCancerPerguntaOpcaoEnum.NUNCA_FORAM_EXAMINADAS_ANTERIORMENTE,
    label: 'Nunca foram examinadas anteriormente',
  },
  { value: RastreioCancerPerguntaOpcaoEnum.NAO, label: 'Não' },
]

export const noduloCarocoOptions = [
  { value: RastreioCancerPerguntaOpcaoEnum.SIM_MAMA_DIREITA, label: 'Sim, mama direita' },
  { value: RastreioCancerPerguntaOpcaoEnum.SIM_MAMA_ESQUERDA, label: 'Sim, mama esquerda' },
  { value: RastreioCancerPerguntaOpcaoEnum.NAO, label: 'Não' },
]

export const localizacaoRadioterapiaOptions = [
  { value: RastreioCancerPerguntaOpcaoEnum.DIREITA, label: 'Direita' },
  { value: RastreioCancerPerguntaOpcaoEnum.ESQUERDA, label: 'Esquerda' },
  { value: RastreioCancerPerguntaOpcaoEnum.AMBAS, label: 'Ambas' },
]
export const anamneseCirurgiaTableOptions = [
  {
    label: 'Biopsia cirúrgica incisional',
    valueDireita: MamografiaPerguntaField.biopsiaCirurgicaIncisionalDireita,
    valueEsquerda: MamografiaPerguntaField.biopsiaCirurgicaIncisionalEsquerda,
  },
  {
    label: 'Biopsia cirúrgica excisional',
    valueDireita: MamografiaPerguntaField.biopsiaCirurgicaExcisionalDireita,
    valueEsquerda: MamografiaPerguntaField.biopsiaCirurgicaExcisionalEsquerda,
  },
  {
    label: 'Centralectomia',
    valueDireita: MamografiaPerguntaField.centralectomiaDireita,
    valueEsquerda: MamografiaPerguntaField.centralectomiaEsquerda,
  },
  {
    label: 'Segmentectomia',
    valueDireita: MamografiaPerguntaField.segmentectomiaDireita,
    valueEsquerda: MamografiaPerguntaField.segmentectomiaEsquerda,
  },
  {
    label: 'Dutectomia',
    valueDireita: MamografiaPerguntaField.dutectomiaDireita,
    valueEsquerda: MamografiaPerguntaField.dutectomiaEsquerda,
  },
  {
    label: 'Mastectomia',
    valueDireita: MamografiaPerguntaField.mastectomiaDireita,
    valueEsquerda: MamografiaPerguntaField.mastectomiaEsquerda,
  },
  {
    label: 'Mastectomia poupadora de pele',
    valueDireita: MamografiaPerguntaField.mastectomiaPoupadoraPeleDireita,
    valueEsquerda: MamografiaPerguntaField.mastectomiaPoupadoraPeleEsquerda,
  },
  {
    label: 'Mastectomia poupadora de pele e complexo aréolo-papilar',
    valueDireita: MamografiaPerguntaField.mastectomiaPoupadoraPeleComplexoDireita,
    valueEsquerda: MamografiaPerguntaField.mastectomiaPoupadoraPeleComplexoEsquerda,
  },
  {
    label: 'Linfadenectomia axilar',
    valueDireita: MamografiaPerguntaField.linfadenectomiaAxilarDireita,
    valueEsquerda: MamografiaPerguntaField.linfadenectomiaAxilarEsquerda,
  },
  {
    label: 'Biopsia de linfonodo sentinela',
    valueDireita: MamografiaPerguntaField.biopsiaLinfonodoSentinelaDireita,
    valueEsquerda: MamografiaPerguntaField.biopsiaLinfonodoSentinelaEsquerda,
  },
  {
    label: 'Reconstrução mamária',
    valueDireita: MamografiaPerguntaField.reconstrucaoMamariaDireita,
    valueEsquerda: MamografiaPerguntaField.reconstrucaoMamariaEsquerda,
  },
  {
    label: 'Mastoplastia redutora',
    valueDireita: MamografiaPerguntaField.mastoplastiaRedutoraDireita,
    valueEsquerda: MamografiaPerguntaField.mastoplastiaRedutoraEsquerda,
  },
  {
    label: 'Inclusão de implantes',
    valueDireita: MamografiaPerguntaField.inclusaoImplantesDireita,
    valueEsquerda: MamografiaPerguntaField.inclusaoImplantesEsquerda,
  },
]

export const RISCO_CANCER_MAMA_TOOLTIP_TEXT = `O risco elevado envolve:
1. Mulheres com história familiar de, pelo menos, um parente de primeiro grau com 
   diagnóstico de:
   a. Câncer de mama antes dos 50 anos de idade;
   b. Câncer de mama bilateral ou câncer de ovário em qualquer faixa etária;
2. Mulheres com história familiar de câncer de mama masculino;
3. Mulheres com diagnóstico histopatológico de lesão mamária proliferativa com atipia ou 
   neoplasia lobular in situ;
4. Mulheres com história pessoal de câncer de mama.
`
